import { render } from "./ProjectPhotos.vue?vue&type=template&id=9e3d142e"
import script from "./ProjectPhotos.vue?vue&type=script&lang=js"
export * from "./ProjectPhotos.vue?vue&type=script&lang=js"

import "./ProjectPhotos.vue?vue&type=style&index=0&id=9e3d142e&lang=scss"

import exportComponent from "/home/forge/empireresidential.net/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__